export default __webpack_public_path__ + "static/media/Bengali_em_2.e0277436.mp3";